"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTargetDatabaseFile = exports.getTargetDir = void 0;
var path = require("path");
/**
 * Get the directory that the user targeted
 * when they ran the 'sextant' command
 */
exports.getTargetDir = function () {
    if (process.env.TARGET_DIR) {
        return path.resolve(process.cwd(), process.env.TARGET_DIR);
    }
    return process.cwd();
};
exports.getTargetDatabaseFile = function () {
    return path.resolve(exports.getTargetDir(), 'database.json');
};
